import React, { FC, useEffect } from 'react';

import * as Styled from './PaymentSuccess.styles';

interface PaymentSuccessProps {
  returnUrl?: string | null;
}

const PaymentSuccess: FC<PaymentSuccessProps> = ({ returnUrl = null }) => {
  useEffect(() => {
    if (returnUrl) {
      window.location.assign(returnUrl);
    }
  }, [returnUrl]);

  return (
    <Styled.PaymentSuccessContainer>
      <Styled.PaymentSuccessContent>
        <Styled.PaymentSuccessIcon />

        <h1>Paiement terminé</h1>

        <p>
          Merci pour votre achat. Vous allez recevoir un mail d’activation de votre compte ainsi qu’un mail de
          confirmation d’abonnement pour accéder à nos plateformes !
        </p>
      </Styled.PaymentSuccessContent>

      {returnUrl ? (
        <Styled.PaymentSuccessReturnLink href={returnUrl}>Revenir à l’application</Styled.PaymentSuccessReturnLink>
      ) : (
        <Styled.PaymentSuccessReturnLink href="https://www.platform.garden/">
          Revenir à l’accueil
        </Styled.PaymentSuccessReturnLink>
      )}
    </Styled.PaymentSuccessContainer>
  );
};

export default PaymentSuccess;
